import React from 'react';

import {Icon, Icons} from '@pb/kit-component-icon';

import {noResultPage, noResultPageDescription} from './no-result-page.module.styl';

type Props = {
    title: string,
    description: string,
    margin?: number,
    hideIcon?: boolean,
};

export const NoResultPage = ({title, description, margin = 250, hideIcon}: Props) => (
    <div className={noResultPage} style={{margin: `${margin}px auto`}}>
        <span>
            {!hideIcon ? <Icon type={Icons.INFO}/> : null} <b>{title}</b>
        </span>
        <div className={noResultPageDescription}>
            {description}
        </div>
    </div>
);
